// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-40c433bd] .original-price{text-decoration:line-through;color:#90a4ae;font-weight:400}span[data-v-40c433bd]{word-break:break-word}", ""]);
// Exports
module.exports = exports;
